import { useQuery, useMutation, useQueryClient } from "react-query";
import { EntrepotService } from "$services";
import { CacheInvalidationAction } from "$utils/cache";
import { Warehouse } from "$types";
import useAuth from "./useAuth";

export const useEntrepotQuery = (entrepotId: string | undefined) => {
  return useQuery<Warehouse>(
    [CacheInvalidationAction.GET_ENTREPOT_BY_ID, entrepotId],
    () => EntrepotService.getEntrepotById(entrepotId || ""),
    {
      enabled: !!entrepotId,
      staleTime: 60 * 1000,
    }
  );
};

export const useEntrepotsQuery = (filters: any = {}) => {
  return useQuery<any>(
    [CacheInvalidationAction.GET_ENTREPOTS, filters],
    () => EntrepotService.getEntrepots(filters),
    {
      staleTime: 60 * 1000,
    }
  );
};

export const useUpdateEntrepotMutation = (entrepotId?: string) => {
  const queryClient = useQueryClient();
  const { token } = useAuth();

  return useMutation(
    (data: any) =>
      EntrepotService.updateEntrepot(token, entrepotId || data._id, data),
    {
      onSuccess: () => {
        if (entrepotId) {
          queryClient.invalidateQueries([
            CacheInvalidationAction.GET_ENTREPOT_BY_ID,
            entrepotId,
          ]);
        }
        queryClient.invalidateQueries([CacheInvalidationAction.GET_ENTREPOTS]);
      },
    }
  );
};

export const useAddEntrepotMutation = () => {
  const queryClient = useQueryClient();
  const { token } = useAuth();

  return useMutation((data: any) => EntrepotService.AddEntrepot(token, data), {
    onSuccess: () => {
      queryClient.invalidateQueries([CacheInvalidationAction.GET_ENTREPOTS]);
    },
  });
};
